import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'

// Tipografía de marca Alto Palermo, servida desde el propio bundle (sin CDN ni
// red en tiempo de ejecución). Cada archivo trae varios @font-face con
// `unicode-range`, así que el navegador solo descarga los subconjuntos que la
// interfaz realmente usa (latín y latín extendido para el español).
//   · Source Serif 4 → títulos y hero. Sustituto libre de Minion Pro (mismo
//     diseñador). Ver docs/adr/0010-sistema-de-diseno-alto-palermo.md.
//   · Lexend         → cuerpo de texto e interfaz.
import '@fontsource-variable/source-serif-4'
import '@fontsource-variable/lexend'

import { App } from '@/app/App'
import '@/styles/globals.css'

/**
 * Punto de entrada. Es el único archivo que toca el DOM directamente.
 *
 * `StrictMode` es una ayuda de desarrollo: React monta y desmonta cada
 * componente dos veces a propósito, para exponer efectos mal escritos (los que
 * no limpian lo que crearon). Puede parecer que algo se ejecuta doble — es
 * intencional, y solo pasa en desarrollo. Si un componente se rompe con
 * StrictMode, es que tiene un bug real que aparecería tarde o temprano.
 */
const contenedor = document.getElementById('root')

if (!contenedor) {
  throw new Error('No se encontró el elemento #root en index.html')
}

createRoot(contenedor).render(
  <StrictMode>
    <App />
  </StrictMode>,
)
